import { $el, appShadowRoot } from './elements';
import { debounce } from './debounce';
import { render } from './page';

const iconMap = {
  negative: 'alert',
  info: 'spectrum-info-icon',
  positive: 'spectrum-checkmark-circle',
};
const klasses = Reflect.ownKeys(iconMap);
const delimiter = '|';
const queue = new Set();

const OPEN_TICKET_FORM_NOTICE_CLASS = 'notification--open-ticket-form';
const OPEN_TICKET_FORM_NOTICE_TOP_OFFSET = 12;
let formNoticeListenersBound = false;

function getOpenTicketFormContainer() {
  const allStep = appShadowRoot?.querySelector('#new-open-ticket .all-step');
  if (!allStep || allStep.classList.contains('is-hidden')) {
    return null;
  }

  return appShadowRoot.querySelector('#new-open-ticket .step-1-5-container');
}

function clearOpenTicketFormNoticePosition() {
  const notice = $el.notice;
  if (!notice) {
    return;
  }

  notice.classList.remove(OPEN_TICKET_FORM_NOTICE_CLASS);
  notice.style.removeProperty('--open-ticket-notice-top');
  notice.style.removeProperty('--open-ticket-notice-left');
  notice.style.removeProperty('--open-ticket-notice-max-width');
}

function positionOpenTicketFormNotice() {
  const notice = $el.notice;
  if (!notice || notice.classList.contains('is-hidden')) {
    return;
  }

  const formContainer = getOpenTicketFormContainer();
  if (!formContainer) {
    clearOpenTicketFormNoticePosition();
    return;
  }

  const rect = formContainer.getBoundingClientRect();
  notice.classList.add(OPEN_TICKET_FORM_NOTICE_CLASS);
  notice.style.setProperty(
    '--open-ticket-notice-top',
    `${Math.max(rect.top + OPEN_TICKET_FORM_NOTICE_TOP_OFFSET, 12)}px`,
  );
  notice.style.setProperty('--open-ticket-notice-left', `${rect.left + rect.width / 2}px`);
  notice.style.setProperty('--open-ticket-notice-max-width', `${Math.max(rect.width - 48, 280)}px`);
}

function bindFormNoticeRepositionListeners() {
  if (formNoticeListenersBound) {
    return;
  }

  formNoticeListenersBound = true;
  window.addEventListener('scroll', positionOpenTicketFormNotice, true);
  window.addEventListener('resize', positionOpenTicketFormNotice);
}

export async function dismiss() {
  return new Promise((resolve) => {
    const done = () => {
      $el.notice.removeEventListener('animationend', done);
      render(() => {
        $el.notice.classList.add('is-hidden');
        $el.notice.classList.remove('alert');
        $el.notice.classList.remove('fadeOut');
        clearOpenTicketFormNoticePosition();
        resolve(true);
      });
    };

    $el.notice.addEventListener('animationend', done, false);
    render(() => {
      $el.notice.classList.remove('fadeIn');
      $el.notice.classList.add('fadeOut');
    });
  });
}

export function notice(
  arg = '',
  autohide = false,
  ms = 3e3,
  klass = 'info',
  timeout = 3e3,
  all = false,
  alert = false,
) {
  const lrender = (
    itr = {
      next: () => ({ value: void 0, done: true }),
    },
  ) => {
    const item = itr.next();

    if (item.done === false) {
      const [larg, lklass] = item.value.split(delimiter);

      klasses.forEach((i) => $el.notice.classList.remove(`spectrum-Toast--${i}`));
      $el.noticeIcon.classList[lklass.trim().length === 0 ? 'add' : 'remove']('is-hidden');
      $el.noticeIconImg.setAttribute('src', `/assets/img/${iconMap[klass]}.svg`);
      $el.noticeContent.innerHTML = alert
        ? `<p><span class="has-text-weight-bold">${(larg.split('.')[0] || '').replace('<', '&lt;').replace('>', '&gt;')}. </span> ${(larg.split('.')[1] || '').replace('<', '&lt;').replace('>', '&gt;')}.</p>`
        : `<p>${(larg || '').replace('<', '&lt;').replace('>', '&gt;')}</p>`;
      $el.notice.classList.add(`spectrum-Toast--${lklass}`);
      $el.notice.classList.remove('is-hidden');
      $el.notice.classList.add('fadeIn');

      if (alert) {
        $el.notice.classList.add('alert');
      }

      bindFormNoticeRepositionListeners();
      requestAnimationFrame(positionOpenTicketFormNotice);

      if ($el.noticeBtn) {
        $el.noticeBtn.addEventListener('click', async () => {
          if (!$el.notice.classList.contains('is-hidden')) {
            await dismiss();
            queue.clear();
          }
        });
      }

      if (autohide) {
        debounce(
          'noticeAutoHide',
          async () => {
            if ($el.notice.classList.contains('is-hidden') === false) {
              await dismiss(true);
            }

            if (itr.done === false && all) {
              render(() => lrender(itr));
            } else {
              queue.clear();
            }
          },
          ms,
        );
      } else {
        queue.clear();
      }
    }
  };

  queue.add(`${arg.trim()}${delimiter}${klass}`);
  debounce(
    'notice',
    () => {
      if (queue.size > 0 && $el.notice.classList.contains('is-hidden')) {
        render(() => {
          lrender(queue.values());
          queue.clear();
        });
      }
    },
    timeout,
  );
}
